import { render, staticRenderFns } from "./MobilePlaceholder.vue?vue&type=template&id=8a0f5aae&"
import script from "./MobilePlaceholder.vue?vue&type=script&lang=js&"
export * from "./MobilePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports